import { loadScripts } from '@analytics/util/scriptLoader';
import logger from '@analytics/util/logger';
import Awindow from '@analytics/types/Awindow';
import { Analytics } from '@analytics/types/Analytics';
import { KilkayaAttributes } from '@analytics/trackers/Kilkaya/types/Kilkaya';

declare let window: Awindow;

export default class Kilkaya implements Analytics {
  private kilkaya: Awindow['kilkaya'];

  /**
   * The module and k5aMeta bootstrap config is first loaded via nuxt.config.ts.
   * loadScripts here awaits that load when init() runs before the module has finished loading (browser dedupes same-URL modules).
   */
  public async init() {
    if (!window.kilkaya) {
      try {
        await loadScripts(
          'https://logs.kaya.delfi.ee/683d8da10049ec077c553232.module.js',
          { type: 'module' },
        );
      } catch (e) {
        console.log('Kilkaya init failed', e);
      }
    }

    this.kilkaya = window.kilkaya;
  }

  public pageView(attributes: KilkayaAttributes) {
    if (!this.kilkaya) {
      logger.error('Kilkaya pageview called but library not found on page');
      return;
    }

    // Exclude foreign language channels
    if (attributes.url && /\/(ru|en|pl)\//.test(attributes.url)) {
      return;
    }

    const currentMeta = window.k5aMeta;
    window.k5aMeta = {
      disablePageview: currentMeta?.disablePageview,
      consent: currentMeta?.consent,
      section: currentMeta?.section,
      contentTag: currentMeta?.contentTag,
      ...attributes,
    };

    document.dispatchEvent(new Event('K5A:SpaReady'));
  }
}
